export type TreeViewSize = 'sm' | 'md' | 'lg';
export const ICON_SIZE = 'h-4 w-4 ';
export const treeStyles = {
  container: {
    width: 'w-120',
  },
  row: {
    sm: {
      height: 32, // Numerical value in pixels for virtualizer
      class: 'h-[32px]', // Tailwind class for components
      padding: 'py-0.5 px-1',
      fontSize: 'text-[11px]',
      baseIndent: 20, // Extra space for selection checkbox
      levelIndent: 12,
    },
    md: {
      height: 40,
      class: 'h-[40px]',
      padding: 'py-1 px-1.5',
      fontSize: 'text-xs',
      baseIndent: 22, // Extra space for selection checkbox
      levelIndent: 14,
    },
    lg: {
      height: 48,
      class: 'h-[48px]',
      padding: 'py-1.5 px-2',
      fontSize: 'text-sm',
      baseIndent: 24, // Extra space for selection checkbox
      levelIndent: 16,
    },
  },
  icons: {
    // Consistent icon sizes across all variants
    folder: `${ICON_SIZE} mr-0.5`,
    folderOpen: `${ICON_SIZE} mr-0.5`,
    file: `${ICON_SIZE} mr-1`,
    action: `${ICON_SIZE}`,
  },
  stats: {
    sm: 'text-[10px]',
    md: 'text-[11px]',
    lg: 'text-xs',
  },
  spacing: {
    actions: {
      sm: 'gap-1 ml-1',
      md: 'gap-1.5 ml-1.5',
      lg: 'gap-2 ml-2',
    },
  },
  selection: {
    indicator: {
      sm: 'left-1',
      md: 'left-1.5',
      lg: 'left-2',
    },
  },
};

// Helper function to calculate padding left based on level and size
export const getIndentStyle = (level: number, size: TreeViewSize = 'sm') => {
  const { baseIndent, levelIndent } = treeStyles.row[size];
  return {
    paddingLeft: `${baseIndent + level * levelIndent}px`,
  };
};
